<h1 mat-dialog-title>Submission Status</h1>
<mat-dialog-content>
  <oo-loading-container [status]="state.status">
    <ng-template>
      <mat-list>
        @for (status of state.statuses; track status) {
          <mat-list-item>
            <div class="oo-status-item">
              <span>{{ status.firstName }} {{ status.lastName }}</span>
              <mat-icon>{{ status.submitted ? 'done' : 'clear' }}</mat-icon>
            </div>
          </mat-list-item>
        }
      </mat-list>
    </ng-template>
  </oo-loading-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-button mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>
